import Button, { ButtonProps } from '@material-ui/core/Button';

export default (props: ButtonProps) => {
  const { color = 'primary' } = props;
  return <Button {...props} color={color} />;
};
